import request from "@/utils/request";
// 查询部门列表
export function listDept(query) {
  return request({
    url: "/system/dept/list",
    method: "get",
    params: query
  });
}
// 获取栏目
export function indexMenuSort() {
  return request({
    url: "/web/index/indexMenuSort",
    method: "get"
  });
}

// 查询医院信息
export function getHospitalLs(data) {
  return request({
    url: "/admin/hospital/searchByHospital1",
    method: "post",
    data
  });
}

// 查询信息公开
export function getInfoLs(data) {
  return request({
    url: "/admin/informationRelease/getList",
    method: "post",
    data
  });
}


// 查询信息公开
export function getInfoAround(data) {
  return request({
    url: `/admin/informationRelease/nextAndPre?id=${data.id}`,
    method: "get",
  });
}



// WEBPACK FOOTER //
// ./src/api/dept.js